<template>
    <div class="budgetary-question budgetary-numeric-question">
        
        <fieldset class="form-group" :class="{ 'completed': hasBeenAnswered, 'has-danger': hasError }">
            <label>
                <p>
                    <strong>
                        <slot></slot>
                    </strong>
                </p>
                <input :type="currency ? 'text' : 'number'"
                    ref="input"
                    :name="name"
                    class="form-control"
                    :min="min"
                    :max="max"
                    :value="value"
                    @focus="selectAll"
                    @blur="formatValue"
                    @input="updateValue($event.target.value)">
                <div v-if="hasError" class="form-control-feedback">
                    <span>El valor introducido no es válido, debe ser mínimo {{ min }}</span><span v-if="max"> y máximo {{ max }}</span>.
                </div>
            </label>
        </fieldset>

        <slot v-if="isMinimumValue" name="single"></slot>
        <slot v-if="isMultipleValue" name="multiple"></slot>
        
        <slot v-if="hasBeenAnswered" name="answered"></slot>

    </div>
</template>

<script>

    export default {
        props: {
            min: {
                type: Number,
                required: true
            },
            max: {
                type: Number,
                required: false
            },
            name: {
                type: String,
                required: false
            },
            currency: {
                type: Boolean,
                required: false
            }
        },

        mounted: function () {
            this.formatValue()
        },

        methods: {
            updateValue (value) {
                this.value = value
                
                if (this.currency) {
                    let currency = value.replace(/[.]/g, '').replace(/[,]/g, '.')
                    this.$emit('input', parseFloat(currency))
                    return true
                }
                this.$emit('input', parseInt( value ))
            },
            formatValue: function () {
                if (this.currency && this.value) {
                    let value = this.value.toString().replace(/[.]/g, '').replace(/[,]/g, '.') 
                    this.$refs.input.value = parseFloat(value).toLocaleString('es-ES', {minimumFractionDigits: 2})
                }
            },
            selectAll: function (event) {
                setTimeout(function () {
                    event.target.select()
                }, 0)
            }
        },

        computed: {
            isMinimumValue: function () {
                if ( this.min != null ) {
                    if ( this.value < this.min ) return false;
                }
                return this.value == this.min && this.value != null && ! this.hasError;
            },
            isMultipleValue: function () {
                return this.value > this.min && this.value != null && ! this.hasError;
            },
            hasBeenAnswered: function () {
                return this.value != null && ! this.hasError;
            },
            hasError: function () {
                if ( this.value == null || this.value == "" ) return false;

                if ( this.min != null ) {
                    if ( this.value < this.min ) return true;
                }
                if ( this.max != null ) {
                    if ( this.value > this.max ) return true;
                }
                return false;
            },
        },

        data: function () {
            return {
                value: null,
            }
        },

        destroyed: function () {
            this.$emit( 'input', null );
        },
    }
</script>

<style lang="scss">
    @import "./../../../sass/variables";

    .budgetary-numeric-question {
        > fieldset.completed {
            opacity: 0.35;
            transition: opacity .5s ease-in-out;

            &:hover {
                opacity: 1;
            }
        }

        > .form-group label {
            display: block;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/budgetary/NumericQuestion.vue